import { ChangeEvent, useCallback } from 'react';
import { ICheckboxFieldProps } from '../BaseInputField/BaseInputField.types';
import { Checkbox, CheckboxOnChangeData, useId } from '@fluentui/react-components';

const CheckboxField = (props: ICheckboxFieldProps) => {
    const {
        name,
        label,
        style,
        required,
        disabled,
        onChange,
        className,
        size,
        dataTestid,
        defaultChecked
    } = props;

    const inputId = useId(`switch-${name}`);

    const handleChange = useCallback(
        (_: ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => {
            onChange(data.checked as boolean);
        },
        [onChange]
    );

    return (
        <Checkbox
            id={inputId}
            label={label}
            required={required}
            disabled={disabled}
            style={style}
            name={name}
            checked={props.checked}
            onChange={handleChange}
            labelPosition={'after'}
            className={className}
            size={size}
            data-testid={dataTestid}
            defaultChecked={defaultChecked}
        />
    );
};

export default CheckboxField;
